// Render the donation level selector
import React from "react";
import { useFormContext } from "react-hook-form";

const DonationSelector = (props) => {
  const { register, setValue, setFocus, formState } = useFormContext();
  const amounts = [50, 100, 250, 1000, 10000, "Other"];

  const selectorAction = (e, amount) => {
    e.preventDefault();
    if (typeof amount == "number") {
      setValue("donation_amount", amount);
      setFocus("donation_amount");
    } else {
      setValue("donation_amount", "");
      setFocus("donation_amount");
    }
  };

  return (
    <div className="component-donation-selector with-sidebar">
      <div className="selector-nav with-sidebar-side left">
        {amounts.map(function (amount, index) {
          return (
            <button
              key={index}
              onClick={(e) => {
                selectorAction(e, amount);
              }}
            >
              {typeof amount == "number"
                ? `$${Number(amount).toLocaleString()}`
                : amount}
            </button>
          );
        })}
      </div>
      <div className="with-sidebar-main with-sections">
        <div className="details-donate">
          <div className="field donate">
            ${" "}
            <input
              id="donation_amount"
              type="number"
              name="donation_amount"
              placeholder=" "
              {...register("donation_amount", {
                required: true,
              })}
              className={
                (formState.errors.donation_amount && "error") ||
                (formState.dirtyFields.donation_amount && "valid")
              }
            />
            <label htmlFor="donation_amount">Amount</label>
            <div className="field-error-msg">
              {formState?.errors?.donation_amount?.type === "required" &&
                "Please enter a donation amount"}
            </div>
          </div>
        </div>
        <div>
          <h3>Billing method</h3>
          {props.children}
        </div>
      </div>
    </div>
  );
};
export default DonationSelector;
